<template>
  <v-dialog
    :model-value="modelValue"
    max-width="480"
    @update:model-value="(value: boolean) => emit('update:modelValue', value)"
    @after-leave="resetInput"
  >
    <v-card>
      <v-card-title class="text-h6">Advanced Vehicle Lookup</v-card-title>
      <v-card-subtitle class="text-wrap pb-0">
        Find current or archived vehicle records by VIN.
      </v-card-subtitle>
      <v-card-text class="pt-4">
        <v-text-field
          ref="vinFieldRef"
          v-model="vinInput"
          label="VIN"
          variant="outlined"
          density="comfortable"
          hide-details
          clearable
          autocomplete="off"
          @keyup.enter="submitLookup"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn variant="text" @click="cancel">Cancel</v-btn>
        <v-spacer />
        <v-btn color="primary" variant="flat" :disabled="!normalizedVin" @click="submitLookup">
          Lookup
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { computed, nextTick, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()

const router = useRouter()
const vinInput = ref('')
const vinFieldRef = ref<{ focus: () => void } | null>(null)

const normalizedVin = computed(() => vinInput.value.trim().toUpperCase())

const resetInput = () => {
  vinInput.value = ''
}

const closeDialog = () => {
  emit('update:modelValue', false)
}

const cancel = () => {
  closeDialog()
}

const submitLookup = () => {
  if (!normalizedVin.value) return

  closeDialog()
  router.push({
    path: '/vehicle-lookup',
    query: { vin: normalizedVin.value },
  })
}

watch(
  () => props.modelValue,
  async (open) => {
    if (!open) return
    resetInput()
    await nextTick()
    vinFieldRef.value?.focus()
  },
)
</script>
